<template>
  <div class="navbar">
    <ul class="navitems admin">
      <li class="active" @click="$router.push('/admin/users')">
        <i class="far fa-calendar-alt"></i>
        Switch to Coordinator mode
      </li>
      <li class="active" @click="$router.push('/super/orgs')">
        <i class="far fa-calendar-alt"></i>
        Super Admin
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'TopNav'
}
</script>

<style lang="scss" scoped>
@import "@/style/variables.scss";
@import "@/style/nav.scss";
</style>
